import * as Colors from 'material-ui/styles/colors';
import { NAV_HEIGHT } from 'Layout/MyAccountLayout/dimensions';

export default {
  toolbar: {
    height: NAV_HEIGHT,
    backgroundColor: Colors.grey700,
    zIndex: 1100,
  },
  tableHeaderColumn: {
    height: 35,
  },
  tableRow: {
    height: 98,
    selectedColor: Colors.grey200,
  },
  tableRowColumn: {
    height: 98,
    fontSize: 16,
  },
  flatButton: {
    primaryTextColor: Colors.lightGreen700,
    textColor: Colors.grey700,
  },
  toggle: {
    trackOnColor: Colors.lightGreen400,
    thumbOnColor: Colors.green500,
    trackDisabledColor: Colors.grey400,
    thumbDisabledColor: Colors.grey300,
    trackOffColor: 'rgba(0, 0, 0, 0.2)',
  },
  radioButton: {
    checkedColor: Colors.lightGreen700,
    borderColor: Colors.grey600
  },
  checkbox: {
    boxColor: Colors.grey700,
  },
  subheader: {
    textTransform: 'uppercase',
    fontWeight: 400,
    color: Colors.grey400,
  },
  inkBar: {
    backgroundColor: Colors.lightGreen600
  },
  snackbar: {
    actionColor: Colors.lightGreen500,
  },
};
